import { render } from "./ExpiredAdminNoteModal.vue?vue&type=template&id=4182133b"
import script from "./ExpiredAdminNoteModal.vue?vue&type=script&lang=js"
export * from "./ExpiredAdminNoteModal.vue?vue&type=script&lang=js"

import "./ExpiredAdminNoteModal.vue?vue&type=style&index=0&id=4182133b&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__